import React, { useState, useEffect } from "react";
import './Footer.css'
import Clock from 'react-live-clock';
import { roleName } from '../../roleAccess';
import LanguageSwitcher from '../../../i18n/LanguageSwitcher';
import ThemeSwitcher from '../../../theme/ThemeSwitcher';
import DisplaySizeMenu from '../../../display/DisplaySizeMenu';
import { tr } from '../../../i18n';
// import Ticker from 'react-ticker';

// Phone-width breakpoint, matching the CSS media queries in Footer.css.
// Kept as one shared constant so the JS-side format switch and the CSS
// layout switch always agree on where "phone" starts - if they drifted
// (say CSS breakpoint changed but this number didn't), the clock format
// could get wide again at exactly the width where the CSS narrows the bar.
const PHONE_BREAKPOINT = 480;

const Footer = ({token, setViewMenusState, viewMenusState}) => {

  // The full desktop clock format ("Tuesday, 22/September/2026, 12:59:00
  // PM") is roughly 40 characters — comfortably fits the footer on a
  // desktop/tablet width, but on a phone-width screen it alone is wider
  // than the available space, forcing the whole bar to wrap or overflow
  // behind the logout/fullscreen buttons. There's no CSS way to reformat
  // text, so the format itself switches based on viewport width instead:
  // a short "Tue, 22/09, 12:59 PM" on phones, the full string everywhere
  // else. Re-checked on resize/orientation change, not just on mount, so
  // rotating a phone or resizing a desktop window updates it live.
  const [isPhone, setIsPhone] = useState(
    typeof window !== 'undefined' && window.innerWidth <= PHONE_BREAKPOINT
  );

  useEffect(() => {
    const onResize = () => setIsPhone(window.innerWidth <= PHONE_BREAKPOINT);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  function toggleFullScreen() {
    if (!document.fullscreenElement) {
        document.documentElement.requestFullscreen();
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      }
    }
  }

  // Role label comes from the central matrix (roleAccess) — the old hardcoded
  // names (Account Manager / Technician / …) predated the role renumbering.
  const role = token ? roleName(token) : tr('Not logged in.');

  return(
<>
{/* <div id="ticker">
<Ticker>
        {({ index }) => (
            <>
                <h1>This is the Headline of element #{index}!</h1>
                <img src="www.my-image-source.com/" alt=""/>
            </>
        )}
    </Ticker>
</div> */}
  <div className="footer">
    <div id="clockDiv">
  <Clock
          format={isPhone ? 'ddd, DD/MM, h:mm A' : 'dddd, DD/MMMM/YYYY, h:mm:ss A'}
          ticking={true} />
          </div>
  <div id="logoutDiv">
  {/* "Logged in as: " is dropped on phones - the role name alone is enough
      context, and the label was the single biggest chunk of text competing
      with the icon buttons for a ~360px-wide bar. */}
  <p id="logoutText">{isPhone ? role : tr("Logged in as: {0}", role)}</p>
  {/* Version number is informational, not something anyone needs at a
      glance on a phone - hidden below the phone breakpoint via CSS
      (display:none) rather than removed here, so it's still in the DOM
      for anyone inspecting/debugging a build issue. */}
  <p id="versionText"><b>v</b>{process.env.REACT_APP_VERSION || '2026.11.02'}</p>
  <LanguageSwitcher />
  <DisplaySizeMenu />
  <ThemeSwitcher />
  <button className="fas fa-desktop" id="hideMenuButton" onClick={() => {toggleFullScreen()}} title={tr("Toggle fullscreen")}></button>
  {/* Eye button: hides / shows the navigation menu on every page.
      Open eye = menu visible (click to hide), crossed eye = menu hidden. */}
  <button className={viewMenusState ? "fas fa-eye-slash" : "fas fa-eye"} hidden={!token} id="hideMenuButton" onClick={() => {setViewMenusState(viewMenusState ? false : true)}} title={tr("Hide/View menus")}></button>
  <button hidden={token ? false : true} id="logoutButton" className="fas fa-sign-out-alt" title={tr("Logout")} onClick={() => {
    fetch(`https://${sessionStorage.getItem("ReaderIp")}/v1/authentication/logout`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json', 'Authorization': token.access_token },
      body: JSON.stringify(null)
    });
    sessionStorage.clear();
    window.location.reload(false);}}></button>
  </div>
  </div>

  </>
  );
  }

export default Footer;